module.exports = __webpack_public_path__ + "static/Nokia_wordmark.svg-1066b7c5584997b9178da0b39ebc4e80.png";